export default {
  namespaced: true,
  state: {
    systemClasses: [],
    actTypes: [],
    licenseTypes: [],
    eventTypes: [],
    contractorTypes: [],
    contractorCustomedTypes: [],
    effectTypes: [],
    trainingTypes: [],
    checklistRiskLevelList: [],
    quesTypeList: [],
    operatorList: [],
    numConditionTypeList: [],
  },
  mutations: {
    SET_SYSTEM_CLASS(state, data) {
      state.systemClass = data;
    },
    SET_ACT_TYPE(state, data) {
      state.actType = data;
    },
    SET_LICENSE_TYPE(state, data) {
      state.licenseType = data;
    },
    SET_EVENT_TYPE(state, data) {
      state.eventType = data;
    },
    SET_SYSTEM_CLASSES(state, data) {
      state.systemClasses = data;
    },
    SET_ACT_TYPES(state, data) {
      state.actTypes = data;
    },
    SET_LICENSE_TYPES(state, data) {
      state.licenseTypes = data;
    },
    SET_EVENT_TYPES(state, data) {
      state.eventTypes = data;
    },
    SET_CONTRACTOR_TYPES(state, data) {
      state.contractorTypes = data;
    },
    SET_CONTRACTOR_CUSTOMED_TYPES(state, data) {
      state.contractorCustomedTypes = data;
    },
    SET_EFFECTS(state, data) {
      state.effect = data;
    },
    SET_TRAINING_TYPES(state, data) {
      state.trainingTypes = data;
    },
    SET_CHECKLIST_RISK_LEVEL_LIST(state, data) {
      state.checklistRiskLevelList = data;
    },
    SET_QUESTYPE_LIST(state, data) {
      state.quesTypeList = data;
    },
    SET_OPERATOR_LIST(state, data) {
      state.operatorList = data;
    },
    SET_NUM_CONDITION_TYPE_LIST(state, data) {
      state.numConditionTypeList = data;
    },
  },
  actions: {
    setSystemClass({ commit }, data) {
      commit('SET_SYSTEM_CLASS', data);
    },
    setActType({ commit }, data) {
      commit('SET_ACT_TYPE', data);
    },
    setLicenseType({ commit }, data) {
      commit('SET_LICENSE_TYPE', data);
    },
    setEventType({ commit }, data) {
      commit('SET_EVENT_TYPE', data);
    },
    setSystemClasses({ commit }, data) {
      commit('SET_SYSTEM_CLASSES', data);
    },
    setActTypes({ commit }, data) {
      commit('SET_ACT_TYPES', data);
    },
    setLicenseTypes({ commit }, data) {
      commit('SET_LICENSE_TYPES', data);
    },
    setEventTypes({ commit }, data) {
      commit('SET_EVENT_TYPES', data);
    },
    setContractorTypes({ commit }, data) {
      commit('SET_CONTRACTOR_TYPES', data);
    },
    setContractorCostomedTypes({ commit }, data) {
      commit('SET_CONTRACTOR_CUSTOMED_TYPES', data);
    },
    setEffects({ commit }, data) {
      commit('SET_EFFECTS', data);
    },
    setTrainingTypes({ commit }, data) {
      commit('SET_TRAINING_TYPES', data);
    },
    setChecklistRiskLevelList({ commit }, data) {
      commit('SET_CHECKLIST_RISK_LEVEL_LIST', data);
    },
    setQuesTypeList({ commit }, data) {
      commit('SET_QUESTYPE_LIST', data);
    },
    setOperatorList({ commit }, data) {
      commit('SET_OPERATOR_LIST', data);
    },
    setNumConditionTypeList({ commit }, data) {
      commit('SET_NUM_CONDITION_TYPE_LIST', data);
    },
  },
};
